import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import MarkerList from '../components/MarkerList/MarkerList';
import Map from '../components/Map/Map';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

const Game = ({ inactivity }) => {

    // define variables
    const { locale, location } = useParams();
    
    // change language
    const { i18n } = useTranslation();

    // trigger tracking
    useEffect(() => {

        // set language
        i18n.changeLanguage(locale);

        // perform tracking
        // gtag('event', 'screen_view', {
        //     'screen_name': `game_${locale}`
        // });

        gtag('event', 'page_view', {
            page_path: `/${locale}/game`
        });

        // set inactivity functionality
        inactivity();

    }, []);

    // render html
    return(
        <>
            <MarkerList language={locale} location={location} />
            <Map />
        </>
    );
}

export default Game;